/**
 * Embedded Google Maps with route from origin → (stops) → destination.
 * Live driver position can be overlaid via the `livePosition` prop.
 * Works on iOS Safari, Android Chrome, desktop — uses Google Maps Embed API
 * (no SDK weight, just an iframe).
 */
export default function TripMap({ origin, destination, stops = [], livePosition = null, height = 320, testid = "trip-map" }) {
  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!origin || !destination || !apiKey) {
    return (
      <div className="bg-zinc-950 border border-zinc-800 rounded-lg flex items-center justify-center text-zinc-500 text-sm" style={{ height }} data-testid={`${testid}-empty`}>
        Enter pickup & drop-off to see route
      </div>
    );
  }
  const waypoints = stops.length ? `&waypoints=${stops.map(encodeURIComponent).join("|")}` : "";
  // Use Embed Directions API
  const src = `https://www.google.com/maps/embed/v1/directions?key=${apiKey}&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}${waypoints}&mode=driving&units=imperial`;
  return (
    <div className="relative rounded-lg overflow-hidden border border-zinc-800" data-testid={testid}>
      <iframe
        title="Trip route"
        src={src}
        className="w-full"
        style={{ height, border: 0 }}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        allow="geolocation; fullscreen"
      />
      {livePosition && (
        <div className="absolute top-2 left-2 bg-black/70 backdrop-blur text-amber-400 text-[10px] uppercase tracking-widest px-2 py-1 rounded-full flex items-center gap-1">
          <span className="h-1.5 w-1.5 rounded-full bg-green-400 pulse-dot"/> LIVE GPS · {livePosition.lat.toFixed(4)},{livePosition.lng.toFixed(4)}
        </div>
      )}
    </div>
  );
}
